import '../sass/style.scss';

(function($) {
  $(document).ready(function() {
    $('.hp-slider').bxSlider({
      mode: 'fade',
      controls: false,
      auto: true,
      pause: 6000,
      touchEnabled: false
    });

    $(".btn.search").click(function(e) {
      e.preventDefault();
      $("#search-overlay").addClass("open");
    });

    $("body:not(.logged-in) a.login").click(function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: 0
      }, 400);
      $("#registration-overlay").removeClass("open");
      $("#login-overlay").addClass("open");
      $(".mfp-close").click();
    });

    $("body:not(.logged-in) a.sign-up").click(function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: 0
      }, 400);
      $("#login-overlay").removeClass("open");
      $("#registration-overlay").addClass("open");
    });

    $("body.logged-in a.login").click(function(e) {
      e.preventDefault();
      $("html, body").animate({
        scrollTop: 0
      }, 400);
      document.location.href = "/my-account";
    });

    $("body.logged-in .mission a.join").click(function(e) {
      e.preventDefault();
      document.location.href = "/my-account";
    });

    $("body.logged-in a.sign-up").click(function(e) {
      e.preventDefault();
      document.location.href = "/my-account";
    });

    $("#search-overlay .bg").click(function() {
      $("#search-overlay").removeClass("open");
    });

    $("#login-overlay .bg").click(function() {
      $("#login-overlay").removeClass("open");
    });

    $("#registration-overlay .bg").click(function() {
      $("#registration-overlay").removeClass("open");
    });

    $(".woocommerce-MyAccount-navigation-link--members-area").remove();

    if(!getCookie("cookies")) {
      $("#cookie-popup").show();
    };

    $("#cookie-popup .btn").click(function(e) {
      e.preventDefault();
      $("#cookie-popup").slideUp();
      setCookie("cookies", 1, 365);
    });

    if(!getCookie("first")) {
      $("#first-popup").css( "display", "flex" );
    };

    $("#first-popup .close").click(function(e) {
      e.preventDefault();
      $("#first-popup").fadeOut();
      setCookie("first", 1, 365);
    });

    $("#first-popup .first-pw").click(function(e) {
      setCookie("first", 1, 365);
    });

    $(".woocommerce-info span").click(function(){
      $(".woocommerce-info").slideUp();
    });

    $(".su-spoiler-title").click(function(e){
      let hash = $(this).parent().data("anchor");
      if(history.pushState) {
          history.pushState(null, null, "#" + hash);
      }
      else {
          location.hash = hash;
      }
    });

    // Product options PDC abstrace links
    $(".product-option-18 .product-option-suboption-label-2").after(' <span class="su-lightbox" data-mfp-src="#pdc-1" data-mfp-type="inline" data-mobile="yes"><a href="kavascript:void();">(view abstract)</a></span>');
    $(".product-option-18 .product-option-suboption-label-3").after(' <span class="su-lightbox" data-mfp-src="#pdc-2" data-mfp-type="inline" data-mobile="yes"><a href="kavascript:void();">(view abstract)</a></span>');
    $(".product-option-18 .product-option-suboption-label-4").after(' <span class="su-lightbox" data-mfp-src="#pdc-3" data-mfp-type="inline" data-mobile="yes"><a href="kavascript:void();">(view abstract)</a></span>');
    $(".product-option-19 .product-option-suboption-label-2").after(' <span class="su-lightbox" data-mfp-src="#pdc-4" data-mfp-type="inline" data-mobile="yes"><a href="kavascript:void();">(view abstract)</a></span>');
    $(".product-option-19 .product-option-suboption-label-3").after(' <span class="su-lightbox" data-mfp-src="#pdc-5" data-mfp-type="inline" data-mobile="yes"><a href="kavascript:void();">(view abstract)</a></span>');

    $(".show-login-password").click(function(){
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        $(this).addClass("active");
      } else {
        x.type = "password";
        $(this).removeClass("active");
      }
    });

    $(".show-reg-password").click(function(){
      var x = document.getElementById("reg_password");
      if (x.type === "password") {
        x.type = "text";
        $(this).addClass("active");
      } else {
        x.type = "password";
        $(this).removeClass("active");
      }
    });

    $("#hundred-acre-wood-field").change(function() {
      console.log(1);
      $(".woocommerce-Button.woocommerce-button.button.woocommerce-form-register__submit").attr("disabled", "disabled");
    });

    /* $("#billing_country").change(function(){
      if($("#billing_country").val() != "US") {
        $("select#billing_state").prop('disabled', true);
        $("select#billing_state").hide();
        $("input#billing_state").prop('disabled', false);
        $("input#billing_state").show();
        $("#billing_postcode").attr('placeholder', "Postal Code");
      } else {
        $("select#billing_state").prop('disabled', false);
        $("select#billing_state").show();
        $("input#billing_state").prop('disabled', true);
        $("input#billing_state").hide();
        $("#billing_postcode").attr('placeholder', "ZIP");
      }
    }); */

    $("#billing_postcode").focusout(function() {
      console.log("Focus Out");
    });
  });
})(jQuery);

function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}
